import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useDeviceApi() {
const { config } = useContext(GlobalContext);
const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000";

// ✅ Utility to get headers with token
function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    "X-token": token || "",
  };
}

// ✅ Get all vendor devices
  async function getAllDeliveredDevices({ limit = 5, offset = 0, ...filters }) {
  const response = await fetch(`${BASE_URL}/get_all_delivered_devices`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ limit, offset, ...filters }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch devices");
  return data;
}

// ✅ Get free / unassigned devices (for Service Swap dropdown)
async function getFreeDevices() {
  const response = await fetch(`${BASE_URL}/get_free_devices`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch free devices");
  }

  return data;
}

// ✅ Get all vendor devices
  async function getAllVendorDevices({ limit = 5, offset = 0, ...filters }) {
  const response = await fetch(`${BASE_URL}/get_all_vendor_devices`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ limit, offset, ...filters }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch devices");
  return data;
}

// ✅ Get all device models
  async function getAllDeviceModels({ limit = 5, offset = 0, ...filters }) {
  const response = await fetch(`${BASE_URL}/get_all_device_models`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      limit,
      offset,
      ...filters, // ✅ pass extra filters (search, fromDate, toDate, etc.)
    }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch device models");
  }
  return data;
}


// ✅ Get device model by ID
  async function getDeviceModelById(modelId) {
  const response = await fetch(`${BASE_URL}/device-model/${modelId}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch device model");
  return data;
}

// ✅ Create a device model
  async function createDeviceModel(modelData) {
  const response = await fetch(`${BASE_URL}/create_device_model`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(modelData),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to create device model");
  return data;
}

// ✅ Get all vendor order devices
  async function getAllVendorOrderDevices({ limit = 5, offset = 0 }) {
  const response = await fetch(`${BASE_URL}/get_all_order_device`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ limit, offset }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch order devices");
  return data;
}

// ✅ Bulk create vendor devices
async function createVendorBulkDevice(deviceData) {
  const response = await fetch(`${BASE_URL}/create_vendor_devices_bulk`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(deviceData),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to create vendor device");
  return data;
}

// ✅ Delete device model
  async function deleteDeviceModel(modelId) {
  const response = await fetch(`${BASE_URL}/delete_device_model/${modelId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to delete device model");
  return data;
}

// ✅ Update device model
  async function updateDeviceModel(modelId, modelData) {
  const payload = { modelId, ...modelData };

  const response = await fetch(`${BASE_URL}/update_device_model`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to update device model");
  return data;
}

// ✅ Check if vendor device exists (manufacturerId / macAddress)
async function checkVendorDeviceExists({ serialNumber,manufacturerId, macAddress }) {
  const response = await fetch(`${BASE_URL}/check_vendor_device_exists`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      serialNumber,
      manufacturerId,
      macAddress,
    }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to check device existence");
  }
  return data; // { success: true, exists: boolean }
}

// 🔁 Swap Device + MAC (Service Swap)
async function swapMacAddress({
  oldDeviceId,
  newDeviceId,
  newMacAddress,
  reason = "service_swap",
}) {
  const response = await fetch(`${BASE_URL}/swap_mac_address`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      oldDeviceId,
      newDeviceId,
      newMacAddress,
      reason,
    }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to swap device");
  }

  return data;
}


// 📜 Get MAC Swap History
async function getMacSwapHistory(deviceId) {
  const response = await fetch(`${BASE_URL}/get_mac_swap_history`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      deviceId,
    }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch MAC history");
  }

  return data;
}


 // ✅ RETURN ALL FUNCTIONS
  return {
    getFreeDevices,
     swapMacAddress,
    getMacSwapHistory,
    getAllDeliveredDevices,
    getAllVendorDevices,
    getAllDeviceModels,
    getDeviceModelById,
    createDeviceModel,
    getAllVendorOrderDevices,
    createVendorBulkDevice,
    deleteDeviceModel,
    updateDeviceModel,
    checkVendorDeviceExists
  };
  
}